/**
 * Cart Drawer
 *
 * Server-rendered inside the overlay section group.
 * Uses event delegation so all listeners survive DOM refreshes.
 * Section Rendering API (`?sections=`) keeps the drawer in sync.
 */

/* ── helpers ─────────────────────────────────────────────────── */

function getCartSectionId() {
  var el = document.querySelector('[data-cart-section-id]');
  return el ? el.dataset.cartSectionId : null;
}

function updateCartCount() {
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (data) {
      document.querySelectorAll('.cart-count').forEach(function (el) {
        el.innerHTML = data.item_count > 0 ? data.item_count : '';
        el.classList.toggle('two-digit', data.item_count > 9);
      });
    })
    .catch(console.error);
}

/* ── drawer open / close with focus‑trap (WCAG) ──────────────── */

var _previouslyFocused = null;

function openCartDrawer() {
  var drawer = document.querySelector('.cart-sidebar');
  if (!drawer) return;

  _previouslyFocused = document.activeElement;

  document.body.classList.add('open-drawer');
  document.body.classList.remove('open-menu', 'open-search', 'open-sort', 'open-filter');

  drawer.setAttribute('aria-hidden', 'false');
  drawer.focus();

  setTimeout(function(){
    initSplide();
  }, 100);
}

function closeCartDrawer() {
  var drawer = document.querySelector('.cart-sidebar');
  if (!drawer) return;

  document.body.classList.remove('open-drawer', 'open-menu', 'open-search', 'open-sort', 'open-filter', 'open-shop-look');
  drawer.setAttribute('aria-hidden', 'true');

  if (_previouslyFocused && _previouslyFocused.focus) {
    _previouslyFocused.focus();
  }
   
}

/* ── core: refresh cart drawer via Section Rendering API ───── */

function refreshCart() {
  var sectionId = getCartSectionId();
  if (!sectionId) return Promise.resolve();

  return fetch(window.Shopify.routes.root + '?sections=' + sectionId)
    .then(function (response) { return response.json(); })
    .then(function (data) {
      if (!data[sectionId]) return;

      var wrapper = document.getElementById('shopify-section-' + sectionId);
      if (!wrapper) return;

      var parsed = new DOMParser().parseFromString(data[sectionId], 'text/html');
      var fresh  = parsed.getElementById('shopify-section-' + sectionId);
      if (fresh) {
        wrapper.innerHTML = fresh.innerHTML;
      }

      /* keep drawer visibly open after refresh */
      if (document.body.classList.contains('open-drawer')) {
        var newDrawer = document.querySelector('.cart-sidebar');
        if (newDrawer) newDrawer.setAttribute('aria-hidden', 'false');
      }

      updateCartCount();
      giftDropdownTwoLevel();
      initCartDiscount();
      cartaccordion();
      initCartUpsell();
      handleFreeGift();
    })
    .catch(function (error) {
      console.error('Error refreshing cart:', error);
    });
}

/** Backward-compatible alias – theme.js calls load_cart() */
function load_cart() {
  return refreshCart();
}

/* ── Free gift auto-add / auto-remove ───────────────────────── */

var _freeGiftBusy = false;

function handleFreeGift() {
  var wrapper = document.querySelector('[data-free-gift-enabled="true"]');
  if (!wrapper || _freeGiftBusy) return;

  var variantId = wrapper.dataset.variantId;
  var productId = wrapper.dataset.productId;
  var minAmount = parseInt(wrapper.dataset.minAmount, 10);
  var available = wrapper.dataset.available === 'true';

  if (!variantId || !productId || isNaN(minAmount)) return;

  _freeGiftBusy = true;

  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var nonGiftTotal = 0;
      var giftInCart   = false;
      var giftLine     = null;

      cart.items.forEach(function(item, idx) {
        if (String(item.product_id) === String(productId)) {
          giftInCart = true;
          giftLine   = idx + 1; // Shopify lines are 1-indexed
        } else {
          nonGiftTotal += item.final_line_price;
        }
      });

      var thresholdMet = nonGiftTotal >= minAmount;

      if (thresholdMet && !giftInCart && available) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
        })
          .then(function(r) { return r.json(); })
          .then(function() {
            _freeGiftBusy = false;
            load_cart();
          })
          .catch(function() { _freeGiftBusy = false; });

      } else if (!thresholdMet && giftInCart && giftLine !== null) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: giftLine, quantity: 0 })
        })
          .then(function(r) { return r.json(); })
          .then(function() {
            _freeGiftBusy = false;
            load_cart();
          })
          .catch(function() { _freeGiftBusy = false; });

      } else {
        _freeGiftBusy = false;
      }
    })
    .catch(function() { _freeGiftBusy = false; });
}



// function initSplide() {
//   var sectionId = getCartSectionId();
//   if (!sectionId || typeof Splide === 'undefined') return;

//   var el = document.getElementById('splide-' + sectionId);
//   if (!el) return;

//   /* avoid double-init */
//   if (el.classList.contains('is-initialized')) return;

//   new Splide('#splide-' + sectionId, {
//     type: 'slide',
//     perPage: 5,
//     gap: '8px',
//     pagination: false,
//     arrows: true,
//     breakpoints: {
//       600: { perPage: 5 }
//     },
//     i18n: {
//       prev: 'Previous upsell product',
//       next: 'Next upsell product',
//       slide: 'Go to upsell product %s'
//     }
//   }).mount();
// }

function attachShopLookListeners(wrapper) {
  wrapper.querySelectorAll('.shop-look-button').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var url   = btn.getAttribute('data-url');
      var modal = btn.getAttribute('data-modal');
      fetch(url)
        .then(function(res) { return res.text(); })
        .then(function(response) {
          var doc    = new DOMParser().parseFromString(response, 'text/html');
          var source = doc.getElementById('section-shop-look');
          document.body.classList.add('open-shop-look');
          var popup = document.getElementById(modal)
            ? document.getElementById(modal).querySelector('.shop-look-popup')
            : null;
          if (popup && source) popup.innerHTML = source.innerHTML;
          if (typeof addToCart === 'function') addToCart();
        })
        .catch(console.error);
    });
  });
}

function initCartUpsell() {
  var sectionId = getCartSectionId();
  if (!sectionId) return;

  var wrapper = document.querySelector('.cart-drawer-upsell-wrapper');
  if (!wrapper) {
    initSplide();
    return;
  }

  var hasManual = wrapper.dataset.hasManual === 'true';
  if (hasManual) {
    initSplide();
    attachShopLookListeners(wrapper);
    return;
  }

  var url = wrapper.dataset.upsellUrl;
  if (!url) {
    initSplide();
    return;
  }

  var list = wrapper.querySelector('.cart-drawer-upsell__list');
  if (!list) {
    initSplide();
    return;
  }

  fetch(url)
    .then(function(r) {
      if (!r.ok) throw new Error('Network response was not ok');
      return r.json();
    })
    .then(function(data) {
      /* exclude products already in the cart */
      var cartProductIds = (wrapper.dataset.cartProductIds || '').split(',').filter(Boolean);
      var products = (data.products || []).filter(function(pro) {
        return cartProductIds.indexOf(String(pro.id)) === -1;
      });
      if (!products.length) {
        wrapper.hidden = true;
        return;
      }

      var max = parseInt(wrapper.dataset.max) || 4;

      var el = document.getElementById('splide-' + sectionId);
      if (el && el.splideInstance) {
        el.splideInstance.destroy();
        el.classList.remove('is-initialized', 'show-arrows-desktop', 'show-arrows-mobile');
        el.splideInstance = null;
      }

      list.innerHTML = '';

      products.slice(0, max).forEach(function(pro) {
        var proUrl    = '/products/' + pro.handle;
        var dataUrl   = proUrl + '?view=shop-the-look';
        var variantId = pro.variants && pro.variants.length > 0 ? pro.variants[0].id : '';
        var imgUrl = null;
        var imgAlt = pro.title || '';

        if (pro.featured_image) {
          if (typeof pro.featured_image === 'string') {
            imgUrl = pro.featured_image;
          } else if (pro.featured_image.src) {
            imgUrl = pro.featured_image.src;
            imgAlt = pro.featured_image.alt || pro.title || '';
          }
        }

        if (imgUrl && imgUrl.startsWith('//')) {
          imgUrl = 'https:' + imgUrl;
        }

        if (imgUrl && !imgUrl.includes('width=')) {
          imgUrl = imgUrl + (imgUrl.includes('?') ? '&' : '?') + 'width=400';
        }

        var li = document.createElement('li');
        li.className = 'splide__slide';
        li.innerHTML = [
          '<div class="upsell-card">',
            '<a href="'+proUrl+'" class="upsell-image">',
              imgUrl ? '<img src="' + imgUrl + '" alt="' + imgAlt + '" loading="lazy" width="200" height="200">' : '',
            '</a>',
            '<button class="shop-look-button" data-modal="shopLook" data-id="' + variantId + '" data-url="' + dataUrl + '">',
              '<span aria-hidden="true">',
                '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">',
                  '<circle cx="7.5" cy="7.5" r="7.5" fill="white"/>',
                  '<line x1="7.4" y1="5" x2="7.4" y2="10" stroke="black" stroke-width="0.8"/>',
                  '<line x1="10" y1="7.4" x2="5" y2="7.4" stroke="black" stroke-width="0.8"/>',
                '</svg>',
              '</span>',
            '</button>',
          '</div>'
        ].join('');

        list.appendChild(li);
      });

      initSplide();
      attachShopLookListeners(wrapper);
    })
    .catch(function(e) {
      console.error('[Upsell] fetch failed:', e);
      initSplide();
    });
}

/**
 * Show/hide upsell arrows and progress bar based on slide count and viewport.
 * Desktop threshold: > 5 slides. Mobile threshold: > 3 slides.
 */
function _applyUpsellArrowVisibility(el) {
  if (!el) return;
  var slideCount = el.querySelectorAll('.splide__slide:not(.upsell-skeleton)').length;
  var splide = el.splideInstance;

  /* arrows */
  if (slideCount > 5) el.classList.add('show-arrows-desktop');
  if (slideCount > 3) el.classList.add('show-arrows-mobile');

  /* disable drag when all slides fit without scrolling (nothing to swipe) */
  if (splide) {
    var isMobile = window.innerWidth <= 991;
    splide.options = {
      drag: isMobile ? slideCount > 3 : slideCount > 5,
      breakpoints: {
        991: {
          perMove: 3,
          drag: slideCount > 3,
        },
      },
    };
  }
}

function initSplide() {
  var sectionId = getCartSectionId();
  if (!sectionId || typeof Splide === 'undefined') return;

  var el = document.getElementById('splide-' + sectionId);
  if (!el) return;

  /* avoid double-init */
  if (el.classList.contains('is-initialized')) return;

  var splide = new Splide('#splide-' + sectionId, {
    type: 'slide',
    autoWidth: true,
    gap: '8px',
    pagination: false,
    arrows: true,
    perMove: 5,
    keyboard: 'focused',
    focusableNodes: 'a, button, textarea, input, select, iframe',
    breakpoints: {
      991: {
        perMove: 3,
      },
    },
    i18n: {
      prev: 'Previous upsell product',
      next: 'Next upsell product',
      slide: 'Upsell products',
      slideX: 'Go to upsell products',
      first: 'Go to first upsell product',
      last: 'Go to last upsell product'
    }
  });

  /* progress bar */
  // var bar = el.querySelector('.splide-progress-bar');
  // var progressContainer = el.querySelector('.splide-progress');

  // if (bar && progressContainer) {
  //   splide.on('mounted move updated', function () {
  //     var end = splide.Components.Controller.getEnd();

  //     if (end > 0) {
  //       progressContainer.style.display = 'block';

  //       var progress = splide.index / end;
  //       var thumbWidth = Math.max(1 / (end + 1), 0.2);

  //       bar.style.width = (thumbWidth * 100) + '%';

  //       var maxMargin = 100 - (thumbWidth * 100);
  //       bar.style.marginLeft = (progress * maxMargin) + '%';
  //     } else {
  //       progressContainer.style.display = 'none';
  //     }
  //   });
  // }

  splide.mount();
  el.splideInstance = splide;
  el.classList.add('is-initialized');

  /* show/hide arrows based on slide count + viewport thresholds */
  _applyUpsellArrowVisibility(el);
}
/* ── cart mutations ───────────────────────────────────────────── */

function updateCartItemQuantity(line, quantity, row) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: line, quantity: quantity })
  })
    .then(function (r) { 
      if (!r.ok) return r.json().then(d => { throw d; });
      return r.json(); 
    })
    .then(function () { refreshCart(); })
    .catch(function (e) { 
      console.error('Error updating cart:', e); 
      if (row) {
        var errorEl = row.querySelector('.cart-qty-error');
        if (errorEl) {
          errorEl.textContent = errorEl.dataset.maxQty || 'The maximum quantity of this item is already in your cart.';
          errorEl.style.display = 'block';
          setTimeout(function() {
            errorEl.style.display = 'none';
          }, 3000);
        }
      }
    });
}

/* ── discount helpers (COMMENTED OUT - using 3rd party app) ────────────────────────────────────────── */

// function fetchCurrentDiscountCodes() {
//   return fetch('/cart.js', { method: 'GET' })
//     .then(function (r) { return r.json(); })
//     .then(function (data) {
//       var codes = [];
//       if (data.cart_level_discount_applications) {
//         data.cart_level_discount_applications.forEach(function (d) {
//           if (d.type === 'discount_code') codes.push(d.title);
//         });
//       }
//       if (data.items) {
//         data.items.forEach(function (item) {
//           if (item.line_level_discount_allocations && item.line_level_discount_allocations.length) {
//             item.line_level_discount_allocations.forEach(function (d) {
//               if (d.discount_application && d.discount_application.type === 'discount_code') {
//                 codes.push(d.discount_application.title);
//               }
//             });
//           }
//         });
//       }
//       return codes.filter(function (v, i, a) { return a.indexOf(v) === i; });
//     });
// }

// function applyDiscountCode(discountCode) {
//   var errorEl = document.querySelector('.custom-discount-form p.error');

//   fetchCurrentDiscountCodes().then(function (codes) {
//     if (codes.indexOf(discountCode) !== -1) {
//       if (errorEl) {
//         errorEl.style.display = 'block';
//         errorEl.textContent = 'Discount code already applied';
//       }
//       return;
//     }
//     codes.push(discountCode);

//     fetch('/checkout?discount=' + codes.map(encodeURIComponent).join(','), { method: 'GET' })
//       .finally(function () {
//         fetch('/cart.js', { method: 'GET' })
//           .then(function (r) { return r.json(); })
//           .then(function (data) {
//             var applied = [];
//             if (data.cart_level_discount_applications) {
//               data.cart_level_discount_applications.forEach(function (d) {
//                 if (d.type === 'discount_code') applied.push(d.title);
//               });
//             }
//             data.items.forEach(function (item) {
//               if (item.line_level_discount_allocations) {
//                 item.line_level_discount_allocations.forEach(function (d) {
//                   if (d.discount_application && d.discount_application.type === 'discount_code') {
//                     applied.push(d.discount_application.title);
//                   }
//                 });
//               }
//             });
//             if (applied.indexOf(discountCode) === -1) {
//               if (errorEl) {
//                 errorEl.style.display = 'block';
//                 errorEl.textContent = 'Enter a valid discount code or gift card';
//               }
//             } else {
//               refreshCart();
//               var inp = document.querySelector('.custom-discount-form input');
//               if (inp) inp.value = '';
//             }
//           });
//       });
//   });
// }

// function removeDiscountCode(code) {
//   fetchCurrentDiscountCodes().then(function (codes) {
//     var remaining = codes.filter(function (c) { return c !== code; });
//     fetch('/checkout?discount=' + remaining.map(encodeURIComponent).join(','), { method: 'GET' })
//       .finally(function () { refreshCart(); });
//   });
// }

/* ── delegated click handler (survives DOM refreshes) ────────── */

document.addEventListener('click', function (e) {

  /* Open cart drawer */
  if (e.target.closest('.header-cart')) {
    openCartDrawer();
    return;
  }

  /* Close cart drawer */
  if (e.target.closest('.overlay-box') || e.target.closest('.cart-drawer-close')) {
    if (e.target.closest('.overlay-box') && document.body.classList.contains('open-shop-look')) {
      document.body.classList.remove('open-shop-look');
      return;
    }
    closeCartDrawer();
    return;
  }

  /* Remove line item */
  var removeBtn = e.target.closest('.item-remove');
  if (removeBtn) {
    e.preventDefault();
    updateCartItemQuantity(removeBtn.dataset.line, 0);
    return;
  }

  /* Qty + (scoped to .cart-drawer) */
  if (e.target.closest('.cart-drawer .qty-plus')) {
    var row = e.target.closest('.item-row');
    if (!row) return;
    var input = row.querySelector('.qty-input');
    var rm    = row.querySelector('.item-remove');
    if (!input || !rm) return;
    updateCartItemQuantity(rm.dataset.line, (parseInt(input.value, 10) || 1) + 1, row);
    return;
  }

  /* Qty − */
  if (e.target.closest('.cart-drawer .qty-minus')) {
    var row2   = e.target.closest('.item-row');
    if (!row2) return;
    var input2 = row2.querySelector('.qty-input');
    var rm2    = row2.querySelector('.item-remove');
    if (!input2 || !rm2) return;
    var qty = parseInt(input2.value, 10) || 1;
    updateCartItemQuantity(rm2.dataset.line, qty > 1 ? qty - 1 : 0, row2);
    // if (qty > 1) {
    //   updateCartItemQuantity(rm2.dataset.line, qty - 1);
    // }
    return;
  }

  /* Upsell add-to-cart */
  var upsellBtn = e.target.closest('.js-upsell-add-to-cart');
  if (upsellBtn) {
    var variantId = upsellBtn.dataset.variantId;
    if (!variantId) return;
    upsellBtn.classList.add('loading');
    upsellBtn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Add to cart failed');
        return r.json();
      })
      .then(function () { refreshCart(); })
      .catch(function (err) { console.error('Upsell add to cart error:', err); })
      .finally(function () {
        upsellBtn.classList.remove('loading');
        upsellBtn.disabled = false;
      });
    return;
  }

  /* Apply discount code (COMMENTED OUT - using 3rd party app) */
  // if (e.target.closest('.submit-discount')) {
  //   var inputEl  = document.querySelector('.custom-discount-form input');
  //   var errorEl2 = document.querySelector('.custom-discount-form p.error');
  //   var code2    = inputEl ? inputEl.value.trim() : '';
  //   if (errorEl2) errorEl2.style.display = 'none';

  //   if (code2 && code2.length) {
  //     applyDiscountCode(code2);
  //   } else if (errorEl2) {
  //     errorEl2.style.display = 'block';
  //     errorEl2.textContent = 'Enter a valid discount code or gift card';
  //   }
  //   return;
  // }

  /* Remove discount code (COMMENTED OUT - using 3rd party app) */
  // var removeDiscount = e.target.closest('.remove-discount');
  // if (removeDiscount) {
  //   removeDiscountCode(removeDiscount.dataset.code);
  //   return;
  // }
});

/* ── keyboard: Escape to close + focus trap ──────────────────── */

document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape' && document.body.classList.contains('open-drawer')) {
    closeCartDrawer();
    return;
  }

  /* Focus trap inside the drawer */
  if (e.key === 'Tab' && document.body.classList.contains('open-drawer')) {
    var drawer = document.querySelector('.cart-sidebar');
    if (!drawer) return;

    var focusable = drawer.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (!focusable.length) return;

    var first = focusable[0];
    var last  = focusable[focusable.length - 1];

    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }
});

/* ── initialise ──────────────────────────────────────────────── */

updateCartCount();
initCartUpsell();

/* ── Sync 3rd party discount app total to cart drawer ─────────── */

function syncThirdPartyTotal() {
  var thirdPartyTotal = document.querySelector('.sc_simple-info__row .money');
  var cartDrawerTotal = document.querySelector('.cart-checkout-button .subtotal-total');

  if (!thirdPartyTotal) return;

  /* Initial sync */
  if (cartDrawerTotal && thirdPartyTotal.textContent) {
    cartDrawerTotal.textContent = thirdPartyTotal.textContent;
  }

  /* Watch for changes using MutationObserver */
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' || mutation.type === 'characterData') {
        var updatedTotal = document.querySelector('.cart-checkout-button .subtotal-total');
        var newValue = thirdPartyTotal.textContent;

        if (updatedTotal && newValue) {
          updatedTotal.textContent = newValue;
        }
      }
    });
  });

  observer.observe(thirdPartyTotal, {
    childList: true,
    characterData: true,
    subtree: true
  });

  /* Also observe the parent container in case the entire .money element gets replaced */
  var parentContainer = document.querySelector('.sc_simple-info__row');
  if (parentContainer) {
    var parentObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          var newThirdPartyTotal = document.querySelector('.sc_simple-info__row .money');
          var updatedTotal = document.querySelector('.cart-checkout-button .subtotal-total');

          if (newThirdPartyTotal && updatedTotal) {
            updatedTotal.textContent = newThirdPartyTotal.textContent;
          }
        }
      });
    });

    parentObserver.observe(parentContainer, {
      childList: true,
      subtree: true
    });
  }
}

/* Initialize sync and re-initialize after cart refreshes */
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    syncThirdPartyTotal();
  });
} else {
  syncThirdPartyTotal();
}

/* Re-sync after cart drawer refreshes (called by refreshCart) */
var originalRefreshCart = refreshCart;
refreshCart = function() {
  return originalRefreshCart().then(function() {
    setTimeout(function() {
      syncThirdPartyTotal();
    }, 100);
  });
};

/* Fallback: Poll for changes every 500ms to catch any missed updates */
var lastKnownValue = '';
setInterval(function() {
  var thirdPartyTotal = document.querySelector('.sc_simple-info__row .money');
  
  if (thirdPartyTotal && thirdPartyTotal.textContent !== lastKnownValue) {
    lastKnownValue = thirdPartyTotal.textContent;
    var cartDrawerTotal = document.querySelector('.cart-checkout-button .subtotal-total');
    if (cartDrawerTotal) {
      cartDrawerTotal.textContent = lastKnownValue;
    }
  }
}, 500);


function giftDropdownTwoLevel() {

  // Level 1: choose_size → expand gift-deskdrop
  document.querySelectorAll(".choose_size").forEach(trigger => {
    const drop = trigger.closest(".comeplementory_product_wrap").querySelector(".gift-deskdrop");
    drop.style.maxHeight = "0px";

    trigger.addEventListener("click", function(e) {
      e.stopPropagation();
      const isOpen = drop.classList.contains("open");
      if (isOpen) {
        drop.style.maxHeight = "0px";
        drop.classList.remove("open");
      } else {
        drop.style.maxHeight = drop.scrollHeight + "px";
        drop.classList.add("open");
      }
    });
  });

  // Level 2: gift-variant-dropdown → expand gift-deskdrop-inner
  document.querySelectorAll(".gift-variant-dropdown").forEach(trigger => {
    const dropInner = trigger.closest(".gift-deskdrop").querySelector(".gift-deskdrop-inner");
    dropInner.style.maxHeight = "0px";

    trigger.addEventListener("click", function(e) {
      e.stopPropagation();
      const isOpen = dropInner.classList.contains("open");
      if (isOpen) {
        dropInner.style.maxHeight = "0px";
        dropInner.classList.remove("open");
      } else {
        // Height handling for mobile transition
        if (window.innerWidth < 992) {
            dropInner.style.maxHeight = "80%";
        } else {
            dropInner.style.maxHeight = dropInner.scrollHeight + "px";
        }
        dropInner.classList.add("open");
      }
    });
  });

  // Handle Close button and Overlay for Mobile Popup
  document.addEventListener("click", (e) => {
    if (e.target.closest(".gift-deskdrop-close") || e.target.closest(".gift-deskdrop-overlay")) {
      closeAllGiftDrops();
    }
  });

  // Function to close all gift dropdowns
  const closeAllGiftDrops = () => {
    document.querySelectorAll(".gift-deskdrop.open, .gift-deskdrop-inner.open").forEach(drop => {
      drop.style.maxHeight = "0px";
      drop.classList.remove("open");
    });
  };

  // Close on outside click
  document.addEventListener("click", (e) => {
    if (!e.target.closest(".comeplementory_product_wrap")) {
      closeAllGiftDrops();
    }
  });

  // Close on scroll/wheel inside cart drawer
  const cartBody = document.querySelector(".cart-sidebar");
  if (cartBody) {
    cartBody.addEventListener("scroll", closeAllGiftDrops, { passive: true });
    cartBody.addEventListener("wheel", closeAllGiftDrops, { passive: true });
  }

  // Close button inside dropdown
  document.querySelectorAll(".gift-close").forEach(btn => {
    btn.addEventListener("click", closeAllGiftDrops);
  });

  // Variant click → add to cart
  document.querySelectorAll(".gift-li").forEach(li => {
    li.addEventListener("click", function() {
      const variantId = this.dataset.varId;
      if (!variantId) return;

      this.classList.add("disabled");

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(res => res.json())
      .then(() => {
        // Close both dropdowns
        const drop = li.closest(".gift-deskdrop");
        const dropInner = drop.querySelector(".gift-deskdrop-inner");

        dropInner.style.maxHeight = "0px";
        dropInner.classList.remove("open");

        drop.style.maxHeight = "0px";
        drop.classList.remove("open");

        if (typeof load_cart === "function") load_cart();
      })
      .finally(() => this.classList.remove("disabled"));
    });
  });

}
function initCartDiscount() {
    const discountWraps = document.querySelectorAll(".cart-discount-wrap");

    discountWraps.forEach(function (wrap) {
      const btn = wrap.querySelector(".cart-discount-custom");

      if (btn) {
        btn.addEventListener("click", function () {
          wrap.classList.toggle("active-discount");
        });
      }
    });
}

function cartaccordion() {
  const buttons = document.querySelectorAll('.accordion-label');

  buttons.forEach(button => {
    button.addEventListener('click', function () {

      const accordionContent = this.nextElementSibling;

      // Close other accordions
      buttons.forEach(otherButton => {
        if (otherButton !== this) {
          otherButton.classList.remove('active_faq');
          const otherContent = otherButton.nextElementSibling;
          if (otherContent) {
            otherContent.style.maxHeight = null;
          }
        }
      });

      // Toggle current accordion
      this.classList.toggle('active_faq');

      if (this.classList.contains('active_faq')) {
        accordionContent.style.maxHeight = accordionContent.scrollHeight + "px";
      } else {
        accordionContent.style.maxHeight = null;
      }

    });
  });

}
document.addEventListener("DOMContentLoaded", cartaccordion);
document.addEventListener("DOMContentLoaded", initCartDiscount);
document.addEventListener("DOMContentLoaded", giftDropdownTwoLevel);
document.addEventListener("DOMContentLoaded", handleFreeGift);
